import React, {  Component } from 'react';
import { connect } from 'react-redux'
import _ from 'lodash';

class ViewPackageOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            packageDetails: []
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
			showDialog: false
		});
		this.props.handleDialog && this.props.handleDialog('ViewPackageOverlayDialog', false);
    }

    componentDidMount() {
        //set packagedetails in state
        this.setState({
            showDialog: this.props.showDialog,
            packageDetails: this.props.orderDetails
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="viewPackageOverlayDialog">
                <div className="blackoutLayer" />
                <div className="overlayDialogWindow viewPackageDialogWidth">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>
                        ×
                    </a>
                    <h2 className="title">
                        View Package
                    </h2>
					<p className="bold">{this.props.packageName}</p>
                    <div style={{height: 300, overflow: 'auto'}}>
                        <table className="addAccessoriesFormTable dataTableType2" style={{marginTop: '0'}}>
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.packageDetails && this.state.packageDetails.length === 0
                                    ?<tr>
                                        <td colSpan={6}>No data found.</td>
                                    </tr>
                                    :null
                                }
                                {this.state.packageDetails && this.state.packageDetails.map((item,index)=>{
                                    return <tr key={index}>
                                        <td key={index}>{item.item}</td>
                                        <td>{item.itemDescription}</td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
   return {state};
};

ViewPackageOverlayDialog = connect(mapStateToProps)(ViewPackageOverlayDialog);
export default ViewPackageOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/viewPackageOverlayDialog.js